export const DISPLAY_NAME = "Orbit";

export const HUD_COPY = {
  credits: "CR",
  income: "PAYOUT",
  level: "Level",
  title: "Spark Initiate",
  daily: "STREAK BONUS",
  dailyState: "Active bonus",
  forge: "Forge",
  auto: "Auto",
  crates: "Crates",
  settings: "Settings",
  help: "Help",
  overdrive: "Overdrive",
  storm: "Storm"
} as const;
